import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import loadConfig from "../../Services/apiService";
import TasksManagerPage from "../../PagesManager/TasksManagerPage";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { ChangeStatustToAllTasksByUserId } from "../../Redux/Reducers/SubTaskFlow";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import Swal from "sweetalert2";

const TasksManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dataJsonObject, SetDataJsonObject] = useState();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const state = useSelector((state) => {
    return {
      RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
      UserInfo: state.UserInfo.UserInfo,
    };
  });
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };
useEffect(()=>{
  dataJson();
},[])
  const ChangeTaskStatus = async () => {
    Swal.fire({
      title: dataJsonObject?.confermPopuPEval?.nameAR,
      icon: "info",
      // iconHtml: "؟",
      confirmButtonText: "تأكيد",
      cancelButtonText: "الغاء",
      showCancelButton: true,
      showCloseButton: true,
    }).then(async (res) => {
      // Callback triggered after user interacts with the popup.
      if (res.isConfirmed == true) {
        const changed = await dispatch(ChangeStatustToAllTasksByUserId());
        if (changed.payload) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تمت العملية بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });
          dispatch(setRefreshTable());
        }
      }
    });
  };
  return (
    <>
      <SharedDiv
        showTitle={true}
        showButton={true}
        titleName="المهام"
        child={[<TasksManagerPage />]}
        id_Title="withBtnTitle"
        buttonComponent={[
          <>
            {state.RoleByUserGuid?.includes(
              "fd21937f-89d0-442e-8010-5b88e360bd48"
            ) ? (
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  ChangeTaskStatus();
                }}
                id="btnTitleEval"
                disabled={false}
                title={"الانتهاء من التقييم لكافة المشاريع"}
                text={"الانتهاء من التقييم لكافة المشاريع"}
                show={true}
              />
            ) : (
              ""
            )}
          </>,
        ]}
      />
    </>
  );
};
export default TasksManager;
